import { render, staticRenderFns } from "./BurgerMenuComponent.vue?vue&type=template&id=b96460d0"
import script from "./BurgerMenuComponent.vue?vue&type=script&lang=js"
export * from "./BurgerMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./BurgerMenuComponent.vue?vue&type=style&index=0&id=b96460d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports